"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _submitConsents = _interopRequireDefault(require("../../api/Customer/submitConsents"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _Consents = _interopRequireDefault(require("../Consents"));
var _LoginStyled = require("../LoginPage/LoginStyled");
var _Button = _interopRequireDefault(require("../Button"));
var _EmailInput = _interopRequireDefault(require("../EmailInput"));
var _PasswordInput = _interopRequireDefault(require("../PasswordInput"));
var _validators = require("../../util/validators");
var _registerCustomer = _interopRequireDefault(require("../../api/Auth/registerCustomer"));
var _getCustomerLocales = _interopRequireDefault(require("../../api/Customer/getCustomerLocales"));
var _auth = _interopRequireDefault(require("../../services/auth"));
var _reactRedux = require("react-redux");
var _jsxRuntime = require("react/jsx-runtime");
class RegisterForm extends _react.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    (0, _defineProperty2.default)(this, "handleClickShowPassword", () => {
      const {
        showPassword
      } = this.state;
      this.setState({
        showPassword: !showPassword
      });
    });
    (0, _defineProperty2.default)(this, "validateEmail", () => {
      const {
        email,
        errors
      } = this.state;
      const {
        t
      } = this.props;
      const message = (0, _validators.validateEmailField)(email);
      this.setState(() => ({
        errors: {
          ...errors,
          email: t(message)
        }
      }));
    });
    (0, _defineProperty2.default)(this, "validatePassword", () => {
      const {
        password,
        errors
      } = this.state;
      const {
        t
      } = this.props;
      const message = (0, _validators.validateRegisterPassword)(password);
      this.setState(() => ({
        errors: {
          ...errors,
          password: t(message)
        }
      }));
    });
    (0, _defineProperty2.default)(this, "validateFields", () => {
      const {
        email,
        password,
        consents,
        consentDefinitions
      } = this.state;
      const {
        t
      } = this.props;
      const errorFields = {
        email: t((0, _validators.validateEmailField)(email)),
        password: t((0, _validators.validateRegisterPassword)(password)),
        consents: t((0, _validators.validateConsentsField)(consents, consentDefinitions))
      };
      this.setState({
        errors: errorFields
      });
      return !Object.keys(errorFields).find(key => errorFields[key] !== '');
    });
    (0, _defineProperty2.default)(this, "handleConsentsChange", (value, consentDefinitions) => {
      this.setState(prev => ({
        consents: value,
        consentDefinitions,
        errors: {
          ...prev.errors,
          consents: ''
        }
      }));
    });
    (0, _defineProperty2.default)(this, "handleSubmit", event => {
      event.preventDefault();
      if (this.validateFields()) {
        this.register();
      }
    });
    (0, _defineProperty2.default)(this, "register", async () => {
      const {
        email,
        password,
        consents,
        consentDefinitions
      } = this.state;
      const {
        onSuccess,
        publisherId,
        t
      } = this.props;
      this.setState({
        processing: true
      });
      const localesResponse = await (0, _getCustomerLocales.default)();
      if (!localesResponse.responseData) {
        this.setState({
          processing: false,
          generalError: t('An error occurred.')
        });
        return false;
      }
      const locales = localesResponse.responseData;
      const response = await (0, _registerCustomer.default)(email, password, publisherId, locales.locale, locales.country, locales.currency);
      if (response.status === 200) {
        _auth.default.login(false, true, email, response.responseData.jwt, response.responseData.refreshToken, _submitConsents.default, [consents, consentDefinitions], onSuccess);
      } else if (response.status === 422) {
        if (response.errors[0].includes('Enterprise account is required')) {
          this.renderError('You would need our product <a href="https://cleeng.com/core-ott-subscriber-management" target="_blank">Core</a> to call this API');
        } else {
          this.renderError('Customer already exists.');
        }
      } else if (response.status === 429) {
        this.setState({
          disableActionButton: true
        });
        this.renderError('Server overloaded. Please try again later.');
        setTimeout(() => {
          this.setState({
            disableActionButton: false,
            generalError: ''
          });
        }, 10 * 1000);
      } else {
        this.setState({
          processing: false,
          generalError: t('An error occurred.')
        });
      }
      return true;
    });
    (0, _defineProperty2.default)(this, "renderError", function () {
      let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'An error occurred.';
      const {
        t
      } = _this.props;
      _this.setState({
        processing: false,
        generalError: t(message)
      });
    });
    (0, _defineProperty2.default)(this, "handlePasswordChange", value => {
      const {
        errors
      } = this.state;
      this.setState({
        password: value,
        errors: {
          ...errors,
          password: ''
        }
      });
    });
    (0, _defineProperty2.default)(this, "disabledRegisterButton", () => {
      this.setState({
        disableActionButton: true
      });
    });
    this.state = {
      email: '',
      password: '',
      consents: [],
      errors: {
        email: '',
        password: '',
        consents: ''
      },
      generalError: '',
      showPassword: false,
      consentDefinitions: [],
      processing: false,
      disableActionButton: false
    };
  }
  render() {
    const {
      email,
      password,
      errors,
      generalError,
      showPassword,
      disableActionButton,
      processing,
      publisherConsentsError
    } = this.state;
    const {
      t
    } = this.props;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LoginStyled.FromStyled, {
      onSubmit: this.handleSubmit,
      noValidate: true,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginStyled.FormErrorStyled, {
        dangerouslySetInnerHTML: {
          __html: generalError
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmailInput.default, {
        label: t('Email'),
        floatingLabels: false,
        value: email,
        onChange: e => this.setState({
          email: e
        }),
        onBlur: this.validateEmail,
        error: errors.email
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordInput.default, {
        label: t('Password'),
        floatingLabels: false,
        value: password,
        onChange: this.handlePasswordChange,
        onBlur: this.validatePassword,
        error: errors.password,
        showVisibilityIcon: true,
        showPassword: showPassword,
        handleClickShowPassword: this.handleClickShowPassword,
        showPasswordStrength: true,
        t: t
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Consents.default, {
        t: t,
        error: errors.consents,
        onChangeFn: this.handleConsentsChange
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        type: "submit",
        size: "big",
        theme: "confirm",
        margin: "10px 0",
        disabled: processing || disableActionButton || publisherConsentsError,
        children: processing ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
          buttonLoader: true,
          color: "#ffffff"
        }) : t('Register')
      })]
    });
  }
}
RegisterForm.propTypes = {
  publisherId: _propTypes.default.string,
  onSuccess: _propTypes.default.func,
  t: _propTypes.default.func
};
RegisterForm.defaultProps = {
  publisherId: '',
  onSuccess: () => undefined,
  t: k => k
};
const mapStateToProps = state => ({
  publisherConsentsError: state.publisherConsents.error
});
exports.mapStateToProps = mapStateToProps;
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps)(RegisterForm);